export default {
  assembly: {
    contactProperties: '接触プロパティ',
    convergenceAdvanced: '収束（詳細設定）',
    allowCutbacks: '増分カットバックを許可',
    allowCutbacksHint:
      '既定はオフ：収束しないステップは、より小さい荷重増分で再試行せず即座に失敗します。誤りではなく難しいと分かっている解析でのみ有効化してください — 失敗までに長時間かかる場合があります。',
    cutbacksDisabled: '無効 — 即時失敗',
    cutbacksEnabled: '有効 — 小さい増分で再試行',
    friction: '摩擦係数 μ（0–2）',
    frictionTooltip:
      'クーロン摩擦は、現在の接触圧力に μ を掛けた限界までせん断を伝えます。空欄または 0 は摩擦なしで、面は自由に滑ります。',
    normalStiffness: '法線剛性（MPa/mm）',
    normalStiffnessTooltip:
      'ペナルティ剛性は接触中の法線方向の貫入を抑えます。有限値のため微小な数値的オーバークロージャを許容し、空欄の場合は材料剛性から算出します。',
    stickSlope: '固着勾配（MPa/mm）',
    stickSlopeTooltip:
      '相対接線変位に対してせん断応力が増える速さです。せん断が概ね μp に達するまでは固着し、それを超えると滑ります。空欄では K/100 を使用します。',
    contactDefaults:
      '摩擦係数が空欄の場合は摩擦なし。剛性の空欄はソルバーが算出します。剛性は正値、固着勾配には摩擦係数の指定が必要です。',
    shrinkTitle: '熱収縮による予荷重',
    shrinkHint:
      '締結部品に等価な組付け締付力を、仮想の温度降下として与えます。熱伝導解析ではなく、thermal_conduction の温度場も読みません。力と軸方向を指定してください。断面サーフェスは任意で、与えた場合のみ実際の力が校正されます。リベット成形のモデル化や断面の作成は行いません。',
    unnamed: '名称未設定の予荷重',
    name: '名称',
    body: '締結部品',
    chooseBody: '部品を選択',
    force: '目標予荷重（N）',
    boltGrade: 'ボルト強度区分',
    boltGradeNone: '未指定',
    boltGradeHint: '予荷重余裕の基準となる保証応力を設定します。',
    areaMode: '軸部モデル',
    threaded: 'メートルねじ',
    smooth: '平滑軸／リベット',
    area: '軸断面積（mm²）',
    size: 'ねじサイズ（M3–M36）',
    axis: '{{axis}} 軸成分',
    section: '断面サーフェス（任意）',
    sectionNone: '指定なし（未校正）',
    sectionEmpty:
      'このメッシュには断面サーフェスがありません。デックは内部サーフェスを除外し、軸部の中間平面は CAD 上でタグ付けできないため、締結アセンブリでは通常存在しません。未指定のままにしてください。',
    sectionUncalibrated:
      '断面サーフェスがない場合、収縮は実測の力に対して校正されません。実際の予荷重は目標値より概ね 15～25% 低くなります。',
    remove: '{{name}} を削除',
    addShrink: '熱収縮予荷重を追加',
    invalid:
      '予荷重の名称、部品、正の力、非ゼロ軸、軸断面積またはねじサイズを入力してください。接触剛性は正値、摩擦係数は 0～2 が必要です。',
  },
  bc: {
    velocityInlet: '速度インレット',
    pressureOutlet: '圧力アウトレット',
    wallNoSlip: '壁（ノースリップ）',
    slip: 'スリップ',
    symmetry: '対称',
    freestream: '自由流',
    unset: '流れの向きを選択',
    groups: {
      unset: '向きの選択が必要',
      inlet: '入口',
      outlet: '出口',
      farfield: '自由流',
      symmetry: '対称',
      wall: '壁面',
    },
    short: {
      inlet: 'インレット',
      outlet: 'アウトレット',
      wall: '壁',
      slip: 'スリップ',
      symmetry: '対称',
      freestream: '自由流',
      unset: '未設定',
    },
  },
  boundaryConditions: {
    untaggedTitle: 'メッシュが未タグ付けです',
    untaggedDescription:
      '選択したメッシュにはまだ名前付きパッチがありません。以下はジオメトリが自動検出した開口です（読み取り専用）。行にカーソルを合わせるとビューアで対応する面がハイライトされます。MeshGen でタグ付けすると、ここで物理割り当てが利用できるようになります。',
    tagInMeshgen: 'MeshGen でタグ付け',
    faceIndex: '面 {{index}}',
    selectForBulk: '{{name}} を一括再割り当て用に選択',
    editPatchName: 'パッチ名を編集',
    rename: '{{name}} の名前を変更',
    blBadgeTooltip:
      'MeshGen の境界層パネル由来のプリズム壁パッチです。既定では壁の物理になります。別の境界条件を持たせたい場合は役割を再割り当てすると、そのグループに移動します。',
    bodyWallTooltip:
      '一括ボディ壁 — 個別にタグ付けされたパッチ以外のすべてのボディ表面の面（例：境界層面）。1 つに統合されたノースリップパッチで、選択するとボディ表面全体がハイライトされます。',
    bodyWallAria: 'body_wall とは？',
    facesCount: '{{count}} 面',
    velocityLockedTitle:
      'ロック中 — この値は上記のスタディ全体の入口速度スイープに由来します（実行ごとに 1 値を適用）。',
    velocityTitle:
      '入口速度の大きさ [m/s]。スタディの流れ軸 ({{axis}}) に沿って一様に適用されます。標準的な外部流の領域ボックスでは、これは自由流速度です。パッチの向きは補正されません — 入口が {{axis}} に垂直でない場合、有効な法線成分は v·cos(角度) です。',
    pressureLockedTitle:
      'ロック中 — この値は上記のスタディ全体の出口圧力スイープに由来します（実行ごとに 1 値を適用）。',
    pressureTitle:
      '出口ゲージ圧 — 絶対圧ではなく周囲圧に対する相対値です。100 Pa と入力すると周囲より 100 Pa 高いことを意味し、絶対 100 Pa ではありません。既定 0 = 出口が周囲圧。運動学形式で保存されます（p/ρ、単位 m²/s²）。Pa/kPa/psi を入力するとフロントエンドが流体密度で除算します。非圧縮性 NS は圧力差のみを解くため、これが基準値を設定します。',
    gaugeLabel: 'ゲージ圧',
    gaugeHint: '（周囲圧に対する相対値）。0 = 出口が周囲圧。',
    patchNamingConvention: 'パッチ命名規則',
    patchNamingBody:
      'ソルバーはメッシュパッチを {{prefix}} 接頭辞付きで書き出し、複数面のタグを {{suffix000}}/{{suffix001}} 接尾辞で分割します。上に表示される名前は meshgen のラベルです — 実行が「パッチ名がメッシュと一致しません」で失敗する場合は、MeshGen の境界割り当てですべての外部表面をタグ付けしたか確認してください。',
    emptyMesh:
      'MeshGen で境界割り当てを開き、表面ゾーンに名前を付けてください。それらの名前がここに表示され、物理割り当てに使えます。',
    assignPhysics:
      '各メッシュパッチに物理を割り当てます。行をクリックするとその面がハイライトされます。',
    viewerHint:
      'ビューアは面プレビュー用に CAD テッセレーションを表示しています — ビューア隅の表示ドロップダウンでメッシュセル表示に切り替えられます。',
    selectedCount: '{{count}} 件選択中',
    assignRolePlaceholder: '境界プロパティを割り当て…',
    clear: 'クリア',
    selectAllGroup: '{{group}} をすべて選択',
    selectCategoryInGroup: '{{group}}の{{category}}をすべて選択',
    showGroupInViewer: 'ビューアで {{group}} を表示',
    hideGroupInViewer: 'ビューアで {{group}} を非表示',
    boundaryLayerFaces: '境界層面',
    wall: '壁',
    studyWideVelocitySweep_one:
      'スタディ全体の入口速度スイープ — {{count}} 値（上記 Inlet · Velocity で設定した 1 つの共有値）。パッチごとのスイープではありません。',
    studyWideVelocitySweep_other:
      'スタディ全体の入口速度スイープ — {{count}} 値（上記 Inlet · Velocity で設定した 1 つの共有値）。パッチごとのスイープではありません。',
    studyWidePressureSweep_one:
      'スタディ全体の出口圧力スイープ — {{count}} 値（上記 Outlet · Pressure で設定した 1 つの共有値）。パッチごとのスイープではありません。',
    studyWidePressureSweep_other:
      'スタディ全体の出口圧力スイープ — {{count}} 値（上記 Outlet · Pressure で設定した 1 つの共有値）。パッチごとのスイープではありません。',
  },
  thermal: {
    labelAdiabatic: '断熱',
    labelFixedTemperature: '固定温度',
    labelHeatFlux: '熱流束',
    labelConvection: '対流',
    labelRadiation: '放射',
    conditionHelp: '{{condition}} の物理的意味',
    helpAdiabatic: 'この面を通る熱流束はゼロです。他の面では熱交換できます。',
    helpFixedTemperature:
      'ソルバーが面を指定温度に保ちます。そのために必要な熱量は入力ではなく結果です。',
    helpHeatFlux:
      '面積あたりの熱流束（W/m²）を指定します。正は面へ熱が流入、負は面から熱が流出します。',
    bulkAssignPlaceholder: '条件を設定…',
    helpConvection:
      '熱伝達係数 h を介して周囲流体と熱交換します。面と周囲の温度に応じて熱は出入りします。',
    helpRadiation:
      '周囲と熱放射を交換します。面は放射すると同時に吸収し、正味の流れは放射率と両者の温度の4乗に依存します。',
    hint: 'メッシュの CalculiX サーフェスごとに熱条件を割り当てます。未指定の面は断熱です。',
    faceConditions: '面の熱条件（{{count}}）',
    noFaces:
      'CalculiX サーフェスがありません — MeshGen で面をタグ付けするか、calculix_surfaces を出力するメッシュを選択してください。',
    temperature: '温度',
    heatFlux: '熱流束',
    convectionH: '熱伝達係数 h',
    ambientTemperature: '周囲温度',
    emissivity: '放射率',
    volumeSourceDisabled: '体積発熱率 — 近日対応予定。',
    pointHeatTitle: '節点熱荷重',
    pointHeatHint:
      'メッシュの節点 ID を指定して総熱量を加えます。再メッシュ後は節点 ID を確認してください。',
    pointNode: 'メッシュ節点 ID',
    pointPick: 'メッシュ上で選択',
    pointPickCancel: '選択を中止',
    pointPickHint:
      '表面要素にカーソルを合わせて最寄りの節点を確認し、クリックして正確なメッシュ節点 ID を選択します。選択中は CAD 表示から解析メッシュに切り替わります。',
    pointPower: '熱量 (W)',
    pointAdd: '節点荷重を追加',
    pointRemove: '節点の熱荷重を削除',
    tieSection: '結合界面',
    createTie: 'タイで結合',
    tieHint:
      'タイは2面の温度を一致させ、独立メッシュの物体間でも熱が伝わります。先に選んだ面が従属（スレーブ）側です — 細かいメッシュ側を選んでください。',
    tieSwap: '{{name}} の従属側を入れ替え',
    tieSwapShort: '入替',
    tieRemove: 'タイ {{name}} を削除',
    tieDirectionHint: '従属（スレーブ）→ 独立（マスター）',
    tieTolerance: '位置公差',
    tieToleranceFor: '{{name}} の位置公差',
    independentBodiesNeedTie:
      '独立メッシュの物体が {{count}} 個あり、熱タイがありません。接触面をタイで結合するか、共有ノードで再メッシュするまで、物体間に熱は伝わりません。',
    categoryTemperature: '固定温度',
    categoryTemperatureHottest: '最高温度',
    categoryTemperatureHotter: '高めの温度',
    categoryTemperatureColder: '低めの温度',
    categoryTemperatureColdest: '最低温度',
    rankHottest: '最高',
    rankHotter: '高め',
    rankColder: '低め',
    rankColdest: '最低',
    detailFixedTemperature: '固定温度',
    detailBonded: '結合',
    detailHeatFlux: '熱流束',
    detailPointHeatLoad: '節点熱荷重',
    detailConvection: '対流',
    detailRadiation: '放射',
    detailNode: '節点',
    categoryHeatFlux: '熱流束',
    categoryHeatPoint: '節点熱荷重',
    categoryConvection: '対流',
    categoryRadiation: '放射',
    categoryTiedInterface: '結合界面',
  },
  cht: {
    labelAdiabatic: '断熱',
    labelFixedTemperature: '固定温度',
    labelConvection: '対流',
    labelSurfaceHeatFlux: '表面熱流束',
    chipFixedT: '固定温度 {{value}} K',
    chipConvection: '対流（周囲空気）',
    convectionAmbientHint: '紫＝周囲空気への放熱であり、流体ではない。',
    chipHeatFlux: '熱流束 {{value}} W/m²',
    chipAdiabatic: '断熱',
    facesCount: '{{count}} 面',
    chipVelocityInlet: '速度入口',
    fluidInletVelocity: '流体入口速度',
    fluidInletVelocityInfo: '流れ軸に沿った入口速度の大きさ。',
    inletTemperature: '入口温度',
    inletTemperatureInfo: '領域に入る流体の温度。',
    chipReferenceOutlet: '基準出口 (0 Pa)',
    referenceOutletBody:
      '固定基準出口：ゲージ圧を 0 Pa に固定します。ほぼ非圧縮性の液体を用いた定常 CHT は、速度入口/基準出口で良設定になります — 調整可能な出口圧を公開しても、同じ流れの基準値がずれるだけで解は変わりません。',
    chipCoupled: '結合',
    chipSolidFluidInterface: '固体↔流体界面',
    expand: '展開',
    collapse: '折りたたむ',
    interfaceHeatPathHint:
      '緑＝固体↔流体接触（冷却材へ熱が伝わる）。外側の紫は周囲空気であり、この界面ではない。',
    interfaceReadOnlyBody:
      '結合界面はソルバーが管理します。ここには編集可能な対流／熱流束はありません。流体 BC は流体メッシュソースで、周囲対流は紫の外面行で設定します。',
    interfaceExplainerLabel: 'この固体–流体界面について',
    interfaceExplainer:
      'この行は結合メッシュパッチ「{{patch}}」です。メッシャーが固体と冷却材が接する面を一つのパッチにまとめ、熱が渡れるようにしています。ここに境界条件は割り当てられません。ホバーまたはクリックでビューアの該当面が点灯します。',
    interfaceSolidK: '{{region}} ({{material}}) · k {{k}} W/(m·K)',
    interfaceFluidK: '{{region}} ({{material}}) · k {{k}} W/(m·K)',
    interfaceSolidMaterial: '{{region}} · {{material}}',
    interfaceFluidMaterial: '{{region}} · {{material}}',
    interfaceFaceList: 'ボディ面: {{faces}}',
    exteriorFaceList: '外面: {{faces}}',
    interfaceVolumeLabel: '体積 {{index}}',
    interfaceVolumeOther: 'その他の面',
    volumeFacesChip: '{{label}} · {{count}} 面',
    faceListToggle: '面リスト · {{count}}',
    chipNoSlipWall: 'ノンスリップ壁',
    chipSlipWall: 'スリップ壁',
    fluidWallNoSlipHint:
      '冷却材はこの壁に張り付きます（ノンスリップ）。CHT ではこのパッチをスリップに切り替えられません。',
    fluidWallExplainerLabel: 'この冷却材壁について',
    fluidWallExplainer:
      '流体領域の壁パッチです。ソルバーは常にノンスリップを書き、壁面で速度をゼロにします。スリップ壁は CHT では使えません — 遠方境界のスリップは外部流れ用です。',
    fluidWallReadOnlyBody:
      '濡れた冷却材壁ではノンスリップが必要です。材料や開口は他の行で変更します。このパッチ種別は編集できません。',
    chipOpeningUnassigned: '向き未設定',
    openingRoleInfo:
      'この開口から冷却材が入るのか、それとも出ていくのか。メッシャーは開口を検出できても流れの向きは判断できないため、指定できるのは利用者だけです。',
    openingUnassigned: '使用しない — 封止する',
    openingInlet: '冷却材が入る',
    openingOutlet: '冷却材が出る',
    openingUnassignedBody:
      'この開口は栓をしたものとして、ソリッドの壁面として扱われます。閉じておきたい注入口には妥当な選択です — ただし冷却材が入る開口と出る開口がそれぞれ 1 つ以上必要です。どちらも無いと流れを駆動するものがありません。',
    openingInletShared:
      '速度と温度は、入口に指定したすべての開口で共有されます — 流入する流れは 1 つで、開口ごとに分かれてはいません。',
    power: '熱流量',
    powerInfo:
      'この面への総熱流量。フロントエンドがパッチ面積で除算して下の流束を導出します。提出されるのは流束です。',
    flux: '流束',
    fluxInfo: '表面熱流束。正 = 固体への熱流入、負 = 表面冷却。',
    noArea: '面積なし',
    powerDisabled:
      'パッチ面積を取得できません — 熱流量入力は無効です。流束を直接設定するか、face_tags に面積データを持つメッシュを選択してください。',
    patchArea: 'パッチ面積：{{area}} cm²',
    solidFaceType: '固体面の境界タイプ',
    solidFaceTypeInfo:
      '断熱 = 完全に絶縁された面。固定温度 = 表面を目標温度に保持。対流 = 対流係数 h を介して周囲と熱交換。',
    temperature: '温度',
    temperatureInfo: '表面温度をこの値に固定します。',
    convectionCoefficient: '対流係数',
    convectionCoefficientInfo:
      '熱伝達係数 h。自然空気 約5、強制空気 約50、水 約1000+、沸騰 約10k+。',
    ambientTemperature: '周囲温度',
    ambientTemperatureInfo: '表面から離れた自由流の温度。',
    adiabaticBody: 'この面には熱流束がありません — 完全に絶縁されています。',
    emptyPatches:
      '各メッシュパッチに熱と流れの物理を割り当てます。MeshGen でメッシュの表面ゾーンをタグ付けすると、ここに個別の行として表示されます。',
    assignPhysics:
      '各メッシュパッチに熱と流れの物理を割り当てます。行をクリックするとビューアでその面がハイライトされます。',
  },
  draftSetup: {
    stepPhysics: '物理条件と境界条件',
    stepStudy: 'スタディ設計',
    geometries: 'ジオメトリ',
    addGeometry: 'ジオメトリを追加',
    inputs: '入力',
    meshInputsKeepSettings:
      '既存のメッシュ入力は保存されたメッシュ設定を保持します。オンザフライのメッシュ化を設定するには、入力の種類をジオメトリに切り替えてください。',
    parameters: 'パラメータ',
    boundaryConditions: '境界条件',
    facesFromMesh: '面は MeshGen で設定済み',
    facesFromMeshTooltip:
      '入口・出口・壁面は MeshGen で命名され、メッシュと一緒に引き継がれます。ここでは物理値を設定してください。面を変更するには MeshGen で再メッシュしてください。',
    setBcBeforeRunning: '実行前に境界条件を少なくとも 1 つ設定してください。',
    solverSettings: 'ソルバー設定',
    run: '実行',
    sectionMesh: 'メッシュ',
    sectionSimulate: 'シミュレート',
    starting: '開始中…',
    runStudy: 'スタディを実行',
    continueToSimulate: 'シミュレートへ進む',
    exceededCap:
      '{{rows}} 個の設計点が {{cap}} 行の上限を超えています — スイープまたは入力を減らしてください',
    largeStudy:
      '{{count}} 個の設計点 — 大規模なスタディには時間がかかる場合があります',
    failedToRun: 'スタディの実行に失敗しました',
    fileKind: 'ファイル種別',
    geometriesToggle: 'ジオメトリ',
    meshesToggle: 'メッシュ',
    hideEnclosure: 'エンクロージャを非表示',
    showEnclosure: 'エンクロージャを表示',
    enclosure: 'エンクロージャ',
    chtSummary: 'CHT · {{flow}} · {{runs}}',
    cfdSummary: '{{parameters}} · {{flow}} · {{runs}}',
    meshInReason: {
      noGeometry: 'ジオメトリを1つ以上追加してください。',
      unmeshed_one:
        '{{count}} 個のジオメトリはまだメッシュが完了していません。',
      unmeshed_other:
        '{{count}} 個のジオメトリはまだメッシュが完了していません。',
      processing_one:
        '{{count}} 個のジオメトリはまだ準備中です（診断または修復）。',
      processing_other:
        '{{count}} 個のジオメトリはまだ準備中です（診断または修復）。',
      needsAttention_one:
        '{{count}} 個のジオメトリはメッシュ化の前に確認が必要です。',
      needsAttention_other:
        '{{count}} 個のジオメトリはメッシュ化の前に確認が必要です。',
      templateMismatch_one:
        '選択したメッシュ {{count}} 個はこのスタディとは別の解析種別用です。このスタディ用に再メッシュするか、選択を外してください。',
      templateMismatch_other:
        '選択したメッシュ {{count}} 個はこのスタディとは別の解析種別用です。このスタディ用に再メッシュするか、選択を外してください。',
      patchMismatch:
        'メッシュ間でパッチ名が異なります — すべてのジオメトリで同じゾーン（inlet/outlet/wall）に名前を付けてください。',
    },
    templateSummary: '{{parameters}} · {{template}} · {{runs}}',
    labelSummary: '{{label}} · {{runs}}',
    runsMobo: '{{count}} 回実行 · MOBO',
    runsFitOnly: '{{count}} 回実行 · 当てはめのみ',
    runs: '{{count}} 回実行',
    paramValue: '{{count}} 値',
    paramList: '{{count}} リスト',
    paramRange: '{{count}} レンジ',
  },
  objectives: {
    title: '目的',
    sobolSamples: 'Sobol サンプル数',
    count: '{{count}} / {{max}}',
    emptyHint:
      '多目的最適化を実行するには目的を少なくとも {{min}} 個追加してください。空のままにすると、最適化せず設計空間をサンプリングします。',
    belowMin:
      'MOBO には目的が {{min}} 個以上必要です — 2 つ目の目的を追加するまで、実行は代理当てはめのみに戻ります。',
    addObjective: '目的を追加',
    addAnother: 'さらに追加',
    advanced: '詳細',
    maxIterations: '最大反復回数',
    candidatesPerIter: '反復あたりの候補数',
    selectMetric: '指標を選択',
    unsupportedMetric: '{{key}}（未対応）',
    notApplicableMetric: '{{label}}（このケースには適用されません）',
    undeterminedMetric: '{{label}}（まだ判断できません）',
    farFieldObjective_one:
      '1 個の目的はこのケースに適用されません。ケースは遠方場の箱の中の物体なので、圧力損失と損失係数は部品ではなく箱を測ります。スタディを実行する前に変更が必要です。代わりに力または力係数を使ってください。',
    farFieldObjective_other:
      '{{count}} 個の目的はこのケースに適用されません。ケースは遠方場の箱の中の物体なので、圧力損失と損失係数は部品ではなく箱を測ります。スタディを実行する前に変更が必要です。代わりに力または力係数を使ってください。',
    undeterminedObjective_one:
      'このケースが流路か遠方場の箱の中の物体かをまだ判断できないため、1 個の圧力損失の目的は意味を持たない可能性があります。先に境界条件を設定するかメッシュを選んでください。',
    undeterminedObjective_other:
      'このケースが流路か遠方場の箱の中の物体かをまだ判断できないため、{{count}} 個の圧力損失の目的は意味を持たない可能性があります。先に境界条件を設定するかメッシュを選んでください。',
    min: '最小',
    max: '最大',
    removeObjective: '目的を削除',
  },
  runPlan: {
    tabulateCht: '領域ごとの温度とピークホットスポット温度を表にまとめる',
    tabulateCfd: '力と各ケースの差分を表にまとめる',
    tabulateFeaStructural: '応力、変位、安全率を表にまとめる',
    tabulateFeaModal: '振動モードと固有振動数を表にまとめる',
    generateDesignPoints_one: '{{count}} 個の設計点を生成',
    generateDesignPoints_other: '{{count}} 個の設計点を生成',
    meshAndSolveCase_one: '{{count}} 個の {{case}} ケースをメッシュ化して解く',
    meshAndSolveCase_other:
      '{{count}} 個の {{case}} ケースをメッシュ化して解く',
    sobolSample:
      '{{ranges}} 個のレンジパラメータにわたり {{samples}} 点を Sobol サンプリング',
    meshAndSolve_one: '{{count}} 個のケースをメッシュ化して解く',
    meshAndSolve_other: '{{count}} 個のケースをメッシュ化して解く',
    fitSurrogate: '{{responses}} にガウス過程代理モデルを当てはめる',
    allResponses: 'すべての応答',
    suggestBatch: 'MOBO で次のバッチを {{goals}} するよう提案',
    minimize: '最小化',
    maximize: '最大化',
    whenYouPressRun: '実行を押すと',
  },
  autoRetry: {
    label: '自動再試行',
    hint: 'ケースが失敗すると、AIが失敗内容を確認し、ソルバー設定を調整して自動で再実行します。',
    maxAttempts: 'ケースあたりの再試行回数',
    meshLabel: 'メッシュの自動再試行',
    meshHint:
      'ジオメトリのメッシュ生成が失敗した場合（または品質ポリシーを満たさない場合）、AIが失敗内容を確認し、メッシュ設定を調整して自動で再実行します。',
    meshMaxAttempts: 'メッシュあたりの再試行回数',
  },
  sampling: {
    samples: 'サンプル数',
    noRanges:
      'Sobol サンプルを使うには、少なくとも 1 つのパラメータを Range に設定してください。',
    advanced: '詳細',
    method: '手法',
    sobolSequence: 'Sobol 列',
    seed: 'シード',
    scramble: 'スクランブル',
    scrambleTooltip:
      'Sobol 列に Owen スクランブルを適用します — 低差異性を失わずに一様性を改善します。',
    totalDesignPoints: '設計点の総数',
    sobolPointsCombos:
      '{{samples}} 個の Sobol 点 × {{combos}} 個の離散組み合わせ',
    sobolPoints: '{{samples}} 個の Sobol 点',
  },
  structural: {
    categoryFixedSupport: '固定支持',
    categoryRollerSupport: 'ローラー支持',
    categoryLoadFace: '荷重面',
    categoryLoadEdge: '荷重エッジ',
    categoryLoadPatch: '点荷重',
    detailFixedSupport: '固定支持',
    detailFixedBody: '固定ボディ',
    detailRestraint: '拘束',
    detailRollerSupport: 'ローラー支持',
    detailFaceLoad: '面荷重',
    detailPressure: '圧力',
    detailAxialCoupling: '軸方向カップリング',
    detailContact: '接触',
    detailFriction: '摩擦',
    detailFrictionless: '摩擦なし',
    detailBothSides: '両側',
    detailSameContactSurfaces: '同じ接触面',
    detailCutPlanePreload: '切断面予荷重',
    detailThermalShrinkPreload: '熱収縮予荷重',
    detailSharedMeshJoin: '共有メッシュ接合',
    detailPointOnly: '点接触のみ',
    detailEdgeOnly: '辺接触のみ',
    detailFaces_one: '{{count}} 面',
    detailFaces_other: '{{count}} 面',
    loadPatch: '点荷重',
    patchPlaceHint: '3Dビューでこの面上の点をクリックしてください。',
    patchPlacing: '点を配置',
    patchPlace: '点を配置',
    patchReplace: '点を移動',
    patchSnapLabel: '点のスナップ先',
    patchSnapNode: 'メッシュ節点',
    patchSnapFace: '面の中心',
    patchSnapFacet: '表面要素',
    loadCountOnFace: '{{label}} の荷重 {{count}} 件',
    patchAt: '{{x}}, {{y}}, {{z}} mm',
    patchRadius: '半径',
    patchRadiusHint:
      'ソリッドに対する点荷重は応力特異点であり、メッシュを細かくするほど最大応力が無限に増大します。半径は同じ合計荷重を実際の接触面積に分散させ、結果を意味のあるものにします。',
    patchNoCenterWarning: '点を配置してください — 点荷重には必要です。',
    categoryFree: '自由',
    collapse: '折りたたむ',
    expand: '展開',
    bcTypeFor: '{{label}} の境界条件タイプ',
    free: '自由',
    fixedSupport: '固定支持',
    rollerSupport: 'ローラー支持',
    loadFace: '荷重面',
    loadEdge: '荷重エッジ',
    pressure: '圧力',
    pressureValue: '圧力',
    nodalLoad: '節点荷重',
    bodyLoads: '物体荷重と連成荷重',
    gravity: '重力',
    addGravity: '重力を追加',
    magnitude: '大きさ',
    centrifugal: '遠心荷重',
    addCentrifugal: '遠心荷重を追加',
    axisDirection: '軸方向',
    axisPoint: '軸上の点（mm）',
    addAxialCoupling: '選択面を軸方向に連成',
    selectFacesForCoupling: '軸方向連成を作成する面を選択してください。',
    forceN: '力（N）',
    displacementMm: '変位（mm）',
    addLoad: '荷重を追加:',
    addLoadFor: '{{label}} に {{kind}} を追加',
    bulkAddFaceLoad: '選択した面に面荷重を追加',
    contactSection: '接触',
    frictionlessLimit:
      '接触は、摩擦係数を設定しない限り摩擦なしとして扱われ、面は抵抗なく滑ります。その場合、接合部の剛性を過小評価することがあり、摩擦で滑りを防ぐ接合部は再現できません。',
    contactSolveLimit:
      '接触を追加すると、荷重の変化に応じて面が離れたり接したりする非線形解析になります。ソルバーが安定した解を求められない場合があります。',
    contactSummary:
      '圧縮のみを伝える接触です。分離は自由で、せん断伝達には摩擦が必要です。',
    contactMechanicsTooltip:
      '接触中はペナルティ法で法線貫入を抑えますが、微小な数値的オーバークロージャを許容します。引張は伝えないため、圧力がゼロになると面は開きます。摩擦なしでは自由に滑り、摩擦ありでは概ね μp 未満で固着し、それを超えると滑ります。常に結合する界面には共有節点を使用してください。接触状態の反復により解析は非線形になります。',
    linearElasticLimit:
      '材料は線形弾性として扱い、永久変形はモデル化しません。降伏応力を超えると、この仮定は成り立ちません。その応力値を実際の応力の予測として扱わないでください。',
    fastenerSection: '締結要素',
    fastenerPreload: '初期張力',
    createFastener: '締結要素を追加',
    fastenerRemove: '締結要素 {{name}} を削除',
    fastenerCutWarning:
      '締結要素には軸部を切断する内部サーフェスが必要で、切断面に隣接するすべての要素が面全体を共有するメッシュ（構造化またはスイープ層）でなければなりません。CalculiX は稜線のみで接する要素を切断面をまたいで結合したままにするため、一般的な四面体メッシュでの切断は、初期張力が不足したまま進行するのではなく拒否されます。',
    contactHint:
      '接触は圧縮のみを伝達し、面の分離を許します（引張も伝達する結合メッシュとは異なります）。最初の面が従属側（スレーブ）です。メッシュの細かい方、または柔らかい方を選んでください。',
    createContact: '接触ペアを作成',
    contactSwap: '{{name}} の従属側を入れ替える',
    contactSwapShort: '入替',
    contactRemove: '接触 {{name}} を削除',
    contactDirectionHint: '従属側（スレーブ）→ 独立側（マスター）',
    independentBodiesNeedContact:
      '{{count}} 個の独立メッシュボディに接触ペアがありません。材料割り当ては各ボディに剛性と密度を与えますが、ボディ同士を接続しません。接触面にペアを追加するか、結合アセンブリには共有節点メッシュを使用してください。',
    clampedLoadWarning:
      'この面は完全に固定されています。クランプは全節点の変位を規定するため、これらの荷重は作用しません。荷重を削除するか、面を解放してください。（固定サポートが受けるせん断力は解析の結果であり、入力ではありません。）',
    addLoadFaceTaken:
      'この面には既に面荷重があります。上で編集するか、力の成分を使用してください',
    removeLoad: '{{kind}}を削除',
    sectionFacesLoads: '{{faces}} 面 · {{loads}} 荷重',
    noEdgesForFace: 'このフェースに利用可能な境界エッジがありません。',
    noEdgeSelectedWarning:
      'エッジを選択してください — 荷重エッジを適用するにはエッジの選択が必要です。',
    selectedCount: '{{count}} 件選択中',
    assignTypePlaceholder: 'タイプを割り当て…',
    clear: 'クリア',
    body: 'ボディ',
    fixedBody: '固定支持',
    bodyGroup: 'ボディ {{index}}',
    material: '材料',
    bodiesAndMaterials: 'ボディと材料',
    bodiesAndMaterialsTooltip:
      '解析に含める各ボリュームには構造材料が必要です。材料は剛性、密度、強度を与えますが、別ボディ同士は接続しません。結合界面には共有節点、独立メッシュの接触面には接触ペアを使用してください。',
    targetBodies: 'ボディ',
    targetFaces: '面',
    categoryTooltip: {
      fixed_face:
        '面上の全節点について X、Y、Z 方向の変位をゼロに規定します。反力は解析結果です。',
      roller_face:
        '選択した変位方向だけを拘束し、選択していない方向の移動は自由です。',
      load_face: '入力した合力を選択面の節点へ分配します。',
      pressure:
        '面の法線方向へ分布荷重を与えます。正圧は面の内側へ作用します。',
      load_point:
        '選択面の節点へ力を分配します。実際の荷重面積が分かる場合は点荷重を使用してください。',
      load_edge: '入力した合力を選択した境界エッジに沿って分配します。',
      load_patch:
        '選択点の周囲の円形領域へ合力を分配し、理想的な集中荷重による応力特異点を避けます。',
      free: '拘束や荷重を追加しません。この面は接触には使用できます。',
    },
    materialFor: '{{name}} の材料',
    role: {
      member: '部材',
      fastener: '締結部品',
      excluded: '除外',
    },
    noNamedFaces:
      '名前付きの面が見つかりません。メッシュ化する前に MeshGen で面をタグ付けして境界条件を設定してください。',
  },
  studyPreview: {
    title: 'スタディプレビュー',
    designPointsLabel_one: '個の設計点',
    designPointsLabel_other: '個の設計点',
    designPointsFormula: '（{{formula}}）',
    formulaManualPart_one: '手動 {{count}} 件',
    formulaManualPart_other: '手動 {{count}} 件',
    emptyState:
      '設計点マトリクスをプレビューするにはファイルを選択してください',
    columnIndex: '#',
    columnIndexLong: '設計点 #',
    columnIndexInfo:
      '設計点 (Design Point) — スタディが実行する 1 ケースにつき 1 行。\n\nスイープ行はソルバー設定のスイープ値の直積展開から生成されます。手動行はユーザーが「＋ 設計点を追加」から作成する個別ケースです。\n\n手動 DP の行をクリックしてオーバーライドを編集。行にマウスを重ねると（ホバー）複製・削除ボタンが表示され、スイープ値セルにマウスを重ねると ✕ が表示されます。',
    columnGeometry: 'ジオメトリ',
    columnElements: '要素',
    columnMeshId: 'メッシュ ID',
    copyMeshId: 'クリックで完全なメッシュ ID をコピー',
    meshIdCopied: 'メッシュ ID をクリップボードにコピーしました',
    showingFirst: '{{total}} 個の設計点のうち最初の 200 個を表示',
    inputsMesh_one: '{{count}} 個のメッシュ',
    inputsMesh_other: '{{count}} 個のメッシュ',
    inputsGeometry_one: '{{count}} 個のジオメトリ',
    inputsGeometry_other: '{{count}} 個のジオメトリ',
    inputsMixed: '{{count}} 個の入力',
    addManualDp: '設計点を追加',
    addManualDpTitle: '設計点を追加',
    editManualDpTitle: '設計点を編集',
    saveManualDp: '保存',
    editingBanner: '編集中の DP：{{label}}',
    doneEditing: '完了',
    editingSweepHint:
      '下のスイープ項目の変更はスイープに反映され、この DP には反映されません。DP の個別オーバーライドは DP のポップオーバーで編集してください。',
    viewingStudyDefaults: 'スタディの既定値を表示中',
    viewingSweepHint:
      'ここでの項目編集はスタディ全体のベースラインになります。軸をオーバーライドしていないすべての設計点がこの値を継承します。',
    editingChipTooltip:
      '手動 DP がフォーカスされています。DP は、そのポップオーバーで上書きした軸を除いてスタディの既定値を継承します。スイープ項目の編集は依然としてスイープリストに反映され、この DP には反映されません。× をクリックして終了。',
    viewingChipTooltip:
      '既定の編集モード。ここで編集した各項目はスタディ全体のベースラインになります — その軸をオーバーライドしていないすべての DP に適用されます。',
    manualDpInput: '入力',
    inputKindGeometry: 'ジオ',
    inputKindMesh: 'メッシュ',
    tagSweep: 'スイープ',
    tagManual: '手動',
    sweepRowFocusTitle: 'スイープ行を表示中',
    sweepRowFocusHint:
      '以下の編集 (流体・BC・ソルバー) は **すべてのスイープ行** に適用されます — スイープ行はすべての値の組み合わせであり、独立した点ではありません. 独自の設定で単一点を固定するには「デザインポイントを追加」で手動 DP を作成してください.',
    sweepRowFocusExit: 'スタディの既定値に戻る',
    tooltipInherit: 'スタディの既定値を継承',
    tooltipUnique: '固有',
    tooltipSharedWith: '{{rows}} と共通',
    removeSweepValue: 'このスイープ値を削除',
    removeSweepValueTooltip: '{{path}} から {{value}} を削除',
    manualDpOverrides: 'オーバーライド',
    manualDpInherit: '継承',
    manualDpLabel: 'タグ（任意）',
    manualDpLabelPlaceholder: '例：fast, open, 最悪ケース',
    duplicateDp: '設計点を複製',
    duplicateAsManual: '手動 DP として複製',
    manualDpColor: '色',
    removeManualDp: 'この設計点を削除',
    manualDpChip_one: '手動 {{count}} 件',
    manualDpChip_other: '手動 {{count}} 件',
    multiSelectHintAria: 'DP テーブルでの複数選択について',
    multiSelectHint:
      '手動 DP の行を Ctrl / Cmd + クリックで選択に追加. Shift + クリックで範囲選択. Ctrl / Cmd + A で表示中の手動 DP を全選択. Delete / Backspace で選択を削除, Escape で解除.\n\n現在, 複数選択は手動 DP のみ対応. スイープ DP は軸のリストを共有しているため, 特定の組み合わせ 1 行 (例: #4 = 速度=1 × 圧力=20) だけを除外するデータモデルが未対応. フォローアップ課題 (BE: excluded_dp_signatures) として追跡中.',
    multiSelectSelected_one: '{{count}} 件選択中',
    multiSelectSelected_other: '{{count}} 件選択中',
    multiSelectDelete: '削除',
    multiSelectClear: '解除',
    selectAllManual: 'すべて選択',
    multiSelectStatusChip_one: '{{count}} 件の DP を選択中',
    multiSelectStatusChip_other: '{{count}} 件の DP を選択中',
    multiSelectChipTooltip_one:
      '手動 DP を {{count}} 件複数選択中. サイドバーの変更はスタディ全体 (またはスイープ) に適用されます. 選択を削除するには Delete キーまたは「手動」チップ横の削除ボタンを使用. × で選択を解除.',
    multiSelectChipTooltip_other:
      '手動 DP を {{count}} 件複数選択中. サイドバーの変更はスタディ全体 (またはスイープ) に適用されます. 選択を削除するには Delete キーまたは「手動」チップ横の削除ボタンを使用. × で選択を解除.',
    multiSelectSidebarHint_one:
      'サイドバーの編集はスタディの既定値 / スイープに適用され, 選択中の {{count}} 件の DP を変更するものではありません. 削除ボタンか Delete キーで選択を削除, Escape で解除.',
    multiSelectSidebarHint_other:
      'サイドバーの編集はスタディの既定値 / スイープに適用され, 選択中の {{count}} 件の DP を変更するものではありません. 削除ボタンか Delete キーで選択を削除, Escape で解除.',
    cancel: 'キャンセル',
  },
  bcValidation: {
    unsetOpening:
      '{{patches}} の流れの向きを選択してください。メッシャーはこれらを流れの開口部と検出しましたが、どちらへ流れるかは判断できません。未設定のままだと開口部は封鎖され、CAD より開口部が少ない状態で計算されます。',
    missingInlet:
      '流れがどこから入るかソルバーが判断できるよう、少なくとも 1 つのパッチを速度入口（または自由流）に選択してください。',
    missingOutlet:
      '少なくとも 1 つのパッチを圧力出口（または自由流）に選択してください。ない場合、圧力方程式が非有界となりソルバーが発散します。',
    patchMismatch:
      'パッチ「{{patch}}」は現在のメッシュにありません — 役割を再選択するか行を削除してください。',
    zeroInletVelocity:
      'スタディ全体の入口速度（物理設定の Inlet · 速度）を 0 より大きい値に設定してください — 面片ごとの行の値だけではこの警告は消えません。既定の 0 はプレースホルダーであり、そのままではスタディを実行できません。',
    zeroPatchVelocity:
      'パッチ「{{patch}}」の速度を 0 より大きい値に設定してください — 0 はプレースホルダーであり、そのままではスタディを実行できません。',
    jumpToField: 'フィールドに移動',
  },
} as const;
